import { useEffect, useState } from 'react';
import * as Styles from './styles';

import P from 'prop-types';
import { Api } from '../../../services/api';
import { DesvinculaPerfil } from './desvinculaPerfil';
import { LoadingCubeComponent } from '../../LoadingCubeComponent';

export const PerfilComponent = ({ id, op }) => {
  const [token, setToken] = useState(null);

  const searchToken = async () => {
    try {
      const obj = await Api.get(`/token/${id}`);

      setToken(obj.data);
    } catch (e) {
      setToken(null);
    }
  };

  useEffect(() => {
    searchToken();
  }, [id]);

  return (
    <div>
      {!token ? (
        <LoadingCubeComponent />
      ) : (
        <>
          <h5>Perfil</h5>
          <div className="form-floating mb-3">
            <Styles.TextArea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style={{ height: '30px' }}
              defaultValue={token.id}
              value={token.id}
            ></Styles.TextArea>
            <label htmlFor="floatingTextarea2">Número</label>
          </div>
          <div className="form-floating mb-3">
            <Styles.TextArea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style={{ height: '30px' }}
              defaultValue={token.motorista}
              value={token.motorista}
            ></Styles.TextArea>
            <label htmlFor="floatingTextarea2">Motorista</label>
          </div>
          <div className="form-floating mb-3">
            <Styles.TextArea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style={{ height: '120px' }}
              defaultValue={token.descricao}
              value={token.descricao}
            ></Styles.TextArea>
            <label htmlFor="floatingTextarea2">Descrição</label>
          </div>
          <div className="form-floating mb-3">
            <Styles.TextArea
              className="form-control"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style={{ height: '30px' }}
              defaultValue={token.transportadora}
              value={token.transportadora}
            ></Styles.TextArea>
            <label htmlFor="floatingTextarea2">Transportadora</label>
          </div>

          {op && op.isCargaView && op.carga && (
            <DesvinculaPerfil id={`${token.transportadora}${token.id}${op.carga}`} />
          )}
        </>
      )}
    </div>
  );
};

PerfilComponent.propTypes = {
  id: P.number,
  op: P.shape({
    isCargaView: P.bool,
    carga: P.number,
  }),
};
